import React from 'react'
import PropTypes from 'prop-types'

import { useFetchAPI } from 'hooks'
import { ErrorBoundary } from 'helpers'
import { Loading } from 'ui/bend'

import VideoPlayerContext from './VideoPlayerContext'
import VideoPlayerLayout from './VideoPlayerLayout'
import VideoPlayerLocked from './VideoPlayerLocked'

const VideoPlayer = ({
  videoId,
  planId,
  planEntryId,
  videoOriginType,
  trialExtend
}) => {
  const [{ data: video, loading: videoLoading, error: videoError }] =
    useFetchAPI(`videos/${videoId}`)
  return (
    <Loading
      loading={videoLoading}
      error={videoError}
      ErrorComponent={<VideoPlayerLocked videoId={videoId} />}
      videoId={videoId}
    >
      {video && (
        <VideoPlayerContext
          src={video.hls}
          poster={video.thumbnail.url}
          videoId={video.id}
          trialExtend={trialExtend}
          planMeta={{
            planId,
            planEntryId,
            videoOriginType,
            duration: video?.durationInMs
          }}
        >
          <VideoPlayerLayout />
        </VideoPlayerContext>
      )}
    </Loading>
  )
}

VideoPlayer.propTypes = {
  videoId: PropTypes.number.isRequired,
  planId: PropTypes.number,
  planEntryId: PropTypes.number,
  videoOriginType: PropTypes.string
}

const SafeVideoPlayer = (props) => (
  <ErrorBoundary>
    <VideoPlayer {...props} />
  </ErrorBoundary>
)

export default SafeVideoPlayer
